/**
 * Single source of truth for the site's public channel links.
 *
 * These used to live in two places with two different conventions: the footer
 * hardcoded a Telegram URL and read a WhatsApp phone number from
 * REACT_APP_WHATSAPP_NUMBER, while the homepage's "Join Telegram & WhatsApp"
 * call to action - the highest-intent control on the site - shipped both
 * buttons as href="#", so clicking either did nothing.
 *
 * Any of these can be overridden at build time (Create React App inlines
 * REACT_APP_* into the bundle):
 *
 *   REACT_APP_TELEGRAM_CHANNEL_URL=https://t.me/<channel>
 *   REACT_APP_WHATSAPP_CHANNEL_URL=https://chat.whatsapp.com/<invite-code>
 *   REACT_APP_WHATSAPP_NUMBER=91XXXXXXXXXX      (legacy: builds a wa.me link)
 *
 * A value that resolves to '' means "not configured", and every consumer must
 * render nothing for that channel rather than a dead link.
 */

const env = (name) => (process.env[name] || '').trim();

/** Defaults to the channel the footer has always linked to. */
export const TELEGRAM_CHANNEL_URL =
  env('REACT_APP_TELEGRAM_CHANNEL_URL') || 'https://t.me/sarkari_adda';

/**
 * A WhatsApp *channel* invite is preferred. REACT_APP_WHATSAPP_NUMBER is the
 * older per-number form the footer already used; it is kept so an existing
 * deployment's .env keeps working. No default: a wrong number would send
 * students to a stranger's chat.
 */
export const WHATSAPP_CHANNEL_URL =
  env('REACT_APP_WHATSAPP_CHANNEL_URL') ||
  (env('REACT_APP_WHATSAPP_NUMBER') ? `https://wa.me/${env('REACT_APP_WHATSAPP_NUMBER')}` : '') ||
  'https://whatsapp.com/channel/sarkariadda24x7';

/** Channels that are actually configured, for copy that names them. */
export const CONFIGURED_CHANNELS = [
  TELEGRAM_CHANNEL_URL && 'Telegram',
  WHATSAPP_CHANNEL_URL && 'WhatsApp',
].filter(Boolean);
